import React from 'react';
import SiteContainer from "../../library/common/layouts/SiteContainer";

const SectionRevolution = () => {
    return(
        <section id="revolution" className='jazenet-revolution bordered-bottom-grey section-point'>
            <div className='section-content'>
                <SiteContainer className="d-md-flex align-items-center justify-content-center">
                    <div className='font-poppins-regular fs-40 fs-md-32 fs-sm-30 text-center px-md-5 mx-md-5 py-5'>
                        <div className='pt-5'></div>
                        <div className='pt-0 mt-md-5'></div>
                        Revolutionize your business with our solutions. From custom applications to seamless integrations, our team of expert developers delivers innovative, scalable, and user-friendly software products tailored to meet your specific needs, driving efficiency and growth like never before.

                        <div className='pt-5'></div>
                        <div className='pt-0 mt-md-5'></div>

                    </div>
                </SiteContainer>
            </div>
        </section>
    )
}

export default SectionRevolution;